import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';

import Alert from 'components/Alert/Alert';

import { AttachmentTypes } from 'types/api';
import { Application } from 'types/applications';
import { Attachment } from 'types/commons';

import {
  AlertType,
  ApplicationTags,
  ClientApplicationStages,
  OfferLetterSteps
} from 'constants/enums';
import { DATE_FORMAT } from 'constants/uiSettings';

import styles from '../OfferView.module.scss';

interface AlertsBlockProps {
  step: OfferLetterSteps;
  offerLetterAttachment: Attachment<AttachmentTypes> | null;
  application?: Application | null;
}

const AlertsBlock = ({
  step,
  offerLetterAttachment,
  application
}: AlertsBlockProps) => {
  const { t } = useTranslation();

  const AlertConfig = [
    {
      type: AlertType.Info,
      message: t('sidebar.application.offer.alerts.offerSubmitted', {
        name: application?.jobseekerFullName,
        date:
          offerLetterAttachment?.createdDate &&
          dayjs(offerLetterAttachment.createdDate).format(DATE_FORMAT)
      }),
      condition:
        step === OfferLetterSteps.OfferLetterSent &&
        application?.tags?.includes(
          ApplicationTags.AcceptedApplicationStageOfferLetterGiven
        )
    },
    {
      type: AlertType.Info,
      message: t('sidebar.application.offer.alerts.candidateAccepted'),
      condition:
        step === OfferLetterSteps.OfferLetterSent &&
        application?.tags?.includes(
          ApplicationTags.AcceptedApplicationStageOfferLetterSigned
        )
    },
    {
      type: AlertType.Warning,
      message: t('sidebar.application.offer.alerts.candidateDeclined'),
      condition:
        application?.tags?.includes(
          ApplicationTags.DeclinedApplicationStageJobseekerRefused
        ) ||
        application?.clientStage ===
          ClientApplicationStages.DeclinedApplicationStageClient
    },
    {
      type: AlertType.Warning,
      message: t('sidebar.application.offer.alerts.offerCanceled'),
      condition: application?.tags?.includes(
        ApplicationTags.DeclinedApplicationStageWithdrawn
      )
    },
    {
      type: AlertType.Warning,
      message: t('sidebar.application.offer.alerts.areYouSure'),
      condition: step === OfferLetterSteps.WithdrawOfferConfirm
    }
  ];

  for (const config of AlertConfig) {
    if (config.condition) {
      return (
        <Alert
          type={config.type}
          message={config.message}
          className={styles.alert}
        />
      );
    }
  }

  return null;
};

export default AlertsBlock;
